import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {live} from 'lit/directives/live.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';

import info from '../../../icons/info';

import store from '../../store';

import {inputRange, staggeredReveal} from '../../css/styleSets';

@customElement('numeric-range')
export class NumericRange extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Function})
	selected = null;

	@property({type: Function})
	isSatisfied = null;

	@property({type: String})
	action = '';

	@property({type: Boolean})
	hideDisabled = false

	@property({type: Function})
	isVisible = () => true;

	@property({type: Number})
	min = 0;

	@property({type: Number})
	max = 100;

	@property({type: Number})
	step = 1;

	@property({type: Number})
	digits = 2;

	@property({type: String})
	unit = '';

	@property({type: Function})
	callback = null;


	@property({type: Boolean})
	twoValues = false

	@property({type: Function})
	selected2 = null;

	@property({type: String})
	action2 = '';

	@property({type: Function})
	callback2 = null;


	static styles = [
		staggeredReveal,
		inputRange,
		css`
			:host {
			}
			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 25px;
			}
			.legend {
				display: flex;
				flex-direction: column;
				justify-content: center;
				font: var(--font-widget-label);
				color: var(--color-widget-border);
			}
			.currentValue {
				display: flex;
				width: 50px;
				white-space: nowrap;
				justify-content: center;
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				font-size: 10px;
				position: absolute;
				left:50%;
				margin-top: -28px;
				margin-left: -25px;
				margin-right: -25px;
			}
			.info {
				color: var(--color-widget-infoicon);
				background-color: transparent;
				cursor: pointer;
				transition: background-color 0.4s, color 0.4s;
				border: none;
				padding: 0;
			}
			.info:hover {
				color: var(--color-widget-text);
			}
			.info svg path {
				fill: currentColor;
				stroke: currentColor;
			}
			.info svg circle {
				stroke: currentColor;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
			.range {
				position: relative;
				width: 100%;
				padding: 18px 0;
			}
			.container {
				display: flex;
				flex-direction: row;
				gap: 20px;
			}

			input {
				position: absolute;
			}
			.track {
				position: absolute;
				width: 100%;
				height: 1px;
				top: 18px;
				background-color: var(--color-widget-border);
			}
			.selectedRangeTrack {
				position: absolute;
				width: 100%;
				height: 1px;
				top: 18px;
				background-color: var(--color-white);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
	}
	async setValue(e) {
		if (this.action !== '') {
			store.dispatch(
				{
					type: this.action,
					payload: {
						value: parseFloat(e.target.value)
					}
				}
			);
		} else if (typeof this.callback === 'function') {
			this.callback(parseFloat(e.target.value));
		}
	}
	async setValue2(e) {
		if (!this.twoValues) return;
		if (this.action2 !== '') {
			store.dispatch(
				{
					type: this.action2,
					payload: {
						value: parseFloat(e.target.value)
					}
				}
			);
		} else if (typeof this.callback2 === 'function') {
			this.callback2(parseFloat(e.target.value));
		}
	}
	render() {

		const s = store.getState();
		if (!this.isVisible(s)) return null;
		const selectedValue = Math.max(this.min, Math.min(this.max, this.selected(s)));
		const range = this.max - this.min;
		const percentage = 2 + (range !== 0 ? ((selectedValue - this.min) / (this.max - this.min)) * 96 : 0);

		const selectedValue2 = this.twoValues ? Math.max(this.min, Math.min(this.max, this.selected2(s))) : null;
		const percentage2 = this.twoValues ? 2 + (range !== 0 ? ((selectedValue2 - this.min) / (this.max - this.min)) * 96 : 0) : 0;

		return html`
			<div class="${classMap({notSatisfied: !this.isSatisfied(s)})}">
				<div class="title">
					${this.title[this.lang]}
				</div>
				<div class="container">
					<div class="legend min">${this.min.toFixed(this.digits)}</div>
					<div class="range">
						<div class="track"></div>
						${when(this.twoValues, () => html`
							<div class="selectedRangeTrack" style="left: ${percentage2}%; width: ${percentage - percentage2}%"></div>
						`)}
						<div class="currentValue" style="left: ${percentage}%">${selectedValue.toFixed(this.digits)} ${this.unit}</div>
						<input class="input value1" type="range"
							   min="${this.min.toFixed(this.digits)}" max="${this.max.toFixed(this.digits)}" step="${this.step.toFixed(this.digits)}"
							   .value=${selectedValue}
							   @input="${this.setValue}">

						${when(this.twoValues, () => html`
							<div class="currentValue" style="left: ${percentage2}%">${selectedValue2.toFixed(this.digits)} ${this.unit}</div>
							<input class="input value1" type="range"
							   min="${this.min.toFixed(this.digits)}" max="${this.max.toFixed(this.digits)}" step="${this.step.toFixed(this.digits)}"
							   .value=${selectedValue2}
							   @input="${this.setValue2}">
						`)}
					</div>
					<div class="legend min">${this.max.toFixed(this.digits)}</div>
				</div>
				</div>
			</div>

		`;
	}
}
